import { inject } from 'mobx-react';
import { TenantDrawerComponent } from './component';
export const TenantDrawer = inject(({ tenantSwitch }) => ({
    availableOptions: tenantSwitch.availableOptions,
    currentOption: tenantSwitch.currentOption,
    loading: tenantSwitch.loading,
    switchTenant: tenantSwitch.switchTenant,
}))(TenantDrawerComponent);
//# sourceMappingURL=index.js.map